import type { ThemeConfig } from "antd";

export const antdTheme: ThemeConfig = {
  token: {
    // Red + white tone (professional, not too saturated)
    colorPrimary: "#D63A3A",
    colorInfo: "#D63A3A",
    colorSuccess: "#1A7F37",
    colorWarning: "#B76E00",
    colorError: "#D63A3A",
    // Text on primary buttons, tags, etc.
    colorTextLightSolid: "#ffffff",
    colorBgBase: "#f7f7f8",
    colorTextBase: "#111114",
    colorBorder: "#e6e6ea",
    borderRadius: 10,
    fontFamily:
      "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      bodyBg: "#f7f7f8",
      siderBg: "#ffffff",
    },
    Menu: {
      itemBg: "#ffffff",
      subMenuItemBg: "#ffffff",
      itemHoverBg: "#fff1f1",
      itemSelectedBg: "#ffe9e9",
      itemSelectedColor: "#A91515",
      itemHoverColor: "#A91515",
    },
    Table: {
      headerBg: "#ffffff",
      headerColor: "#111114",
      rowHoverBg: "#fff6f6",
      borderColor: "#e6e6ea",
    },
    Card: {
      colorBgContainer: "#ffffff",
      colorBorderSecondary: "#e6e6ea",
    },
    Button: {
      defaultBg: "#ffffff",
      defaultBorderColor: "#e6e6ea",
      defaultColor: "#111114",
      primaryShadow: "none",
    },
    Input: {
      colorBgContainer: "#ffffff",
      colorBorder: "#e6e6ea",
      colorText: "#111114",
      colorTextPlaceholder: "#70707a",
    },
  },
};

